import styled from '@emotion/styled';

const Tbody = styled.tbody`
  background-color: white;
  overflow-y: auto;
`;

export default Tbody;
